/* Sticky add-to-cart bar: option chips collapse into a dropdown at 3+ values.
 *
 * The bar mirrors the buy box's picker, so a product with three lengths puts
 * three chips into a strip that also has to hold the title, the price and the
 * button. Two chips fit; three start eating the button's room. Past two, the
 * options become a select.
 *
 * The radios stay in the DOM and remain the source of truth — the theme's
 * VariantRadios reads `fieldset input:checked` to work out the variant, so
 * the select simply checks the matching radio and re-fires its change event.
 * Price, availability and the cart id all keep running on the theme's own
 * code; nothing about variant handling is reimplemented here.
 */
(function () {
  "use strict";

  var DONE = "data-sticky-select";
  var MIN_VALUES = 3;

  function optionLabel(radio, root) {
    var label = root.querySelector('label[for="' + CSS.escape(radio.id) + '"]');
    if (!label) return radio.value;
    var clone = label.cloneNode(true);
    // "Most popular" is a badge on the chip. The buy box above already says
    // it, and in a one-line option it just makes the row noisy.
    var tag = clone.querySelector(".variant-option-tag");
    if (tag) tag.remove();
    return clone.textContent.replace(/\s+/g, " ").trim();
  }

  function convert(fieldset) {
    if (fieldset.hasAttribute(DONE)) return;
    var radios = fieldset.querySelectorAll('input[type="radio"]');
    if (radios.length < MIN_VALUES) return;
    // Swatches are visual by nature — a list of colour names would be worse.
    if (fieldset.querySelector(".color-swatch, .variant-swatch")) return;

    fieldset.setAttribute(DONE, "");

    var select = document.createElement("select");
    select.className = "sticky-bar-variant-select";
    var legend = fieldset.querySelector(".product-form__group-name");
    select.setAttribute(
      "aria-label",
      legend ? legend.textContent.replace(/\s+/g, " ").trim() : "Options"
    );

    radios.forEach(function (radio) {
      var option = document.createElement("option");
      option.value = radio.id;
      option.textContent = optionLabel(radio, fieldset);
      option.disabled = radio.disabled;
      if (radio.checked) option.selected = true;
      select.appendChild(option);
    });

    select.addEventListener("change", function () {
      var radio = fieldset.querySelector(
        '[id="' + CSS.escape(select.value) + '"]'
      );
      if (!radio || radio.checked) return;
      radio.checked = true;
      // The theme listens on the group, not the input, so it has to bubble.
      radio.dispatchEvent(new Event("change", { bubbles: true }));
    });

    // The buy box drives the same variant, so picking a length up there has to
    // move this control too. It does that by setting the radio directly, which
    // fires no event — but it does move the `checked` attribute, and that a
    // MutationObserver can see. Listening for `change` alone left the bar
    // showing the wrong length after every change made in the buy box.
    var sync = function () {
      var checked = fieldset.querySelector("input:checked");
      if (checked && select.value !== checked.id) select.value = checked.id;
    };
    new MutationObserver(sync).observe(fieldset, {
      attributes: true,
      attributeFilter: ["checked"],
      subtree: true,
    });
    fieldset.addEventListener("change", function (event) {
      if (event.target !== select) sync();
    });

    fieldset.appendChild(select);
  }

  function scan() {
    document
      .querySelectorAll(".product-sticky-add-bar .product-form__controls")
      .forEach(convert);
  }

  function init() {
    scan();
    var bar = document.querySelector(".product-sticky-add-bar");
    if (!bar) return;
    // The theme re-renders the picker on some variant changes.
    new MutationObserver(scan).observe(bar, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
